import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { LogoMark } from "@/components/Logo";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const match = location.hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/admin", { replace: true });
      return;
    }
    api
      .post("/auth/session", { session_id: decodeURIComponent(match[1]) })
      .then(() => navigate("/admin", { replace: true }))
      .catch((e) => {
        const status = e?.response?.status;
        setError(
          status === 403
            ? "This Google account is not authorized to access the admin panel."
            : "Sign-in failed or expired. Please try again."
        );
        setTimeout(() => navigate(`/admin${status === 403 ? "?error=403" : ""}`, { replace: true }), 2600);
      });
  }, [location.hash, navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-ink px-6 text-center">
      <LogoMark className="h-14 w-14 animate-float" />
      {error ? (
        <div data-testid="auth-callback-error">
          <p className="font-display text-xl font-bold text-white">{error}</p>
          <p className="mt-2 text-sm text-slate-400">Returning you to the admin panel…</p>
        </div>
      ) : (
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-cyan-400" data-testid="auth-callback-loading">
          Signing you in…
        </p>
      )}
    </div>
  );
}
